export enum CloudWatchAuthType {
  AccessKey = 'accessKey',
  AssumeRole = 'assumeRole',
}

export enum PrometheusAuthType {
  Unspecified = 'unspecified',
  Basic = 'basic',
}
